import React from 'react';
import Dialog from "Components/Core/Dialog";
import Form from 'Components/Core/Form/Form';
import 'CSS/Forum/DialogAddBBCode.css';

export default function DialogAddBBCode(props) {

    const x = props.x;
	const tag = (typeof props.tag === 'undefined') ? 'url' : props.tag;
	const classes = (typeof props.classes === 'undefined') ? '' : props.classes

	x.wad.init(props.id, {
		"setFocus": props.setFocus
	});

	x.waf.init(props.id, {
		"ok": send,
	});

	function send(event) {
		event.preventDefault();
		switch (tag) {
			case 'b':
			case 'u':
			case 'i':
			case 'quote':
				addFormatting();
				break;
			case 'ul':
				addList();
				break;
			case 'url':
				addLink();
				break;
			default:
				addLink();
		}
		props.reset();
		x.waf[x.wad[props.id].wafId].onFormChanged();
	}

	function addFormatting() {
		x.wab.modal.hide();
		x.wad[props.id].hide();

		const curPos = x.waf[x.wad[props.id].wafId].elements['posting'].reference.current.selectionStart;
		const curVal = x.waf.get(x.wad[props.id].wafId, 'posting');
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		const text = x.waf.get(props.id, 'text');
		const newText = leftValue + '[' + tag + ']' + text + '[/' + tag + ']' + rightValue;
		// x.waf.set(x.wad[props.id].wafId, 'posting', leftValue + '[' + tag + ']' + text + '[/' + tag + ']' + rightValue);
		x.waf.set(x.wad[props.id].wafId, 'posting', newText);
		x.waf.focus(x.wad[props.id].wafId, 'posting');
		x.waf.setCursorPos(x.wad[props.id].wafId, 'posting', curPos, curPos);
		x.wau.postingBackup(x.wad[props.id].wafId, props.answerTo, newText)
	}

	function addList() {
		x.wab.modal.hide();
		x.wad[props.id].hide();

		const linesText = x.waf.get(props.id, 'text');
		const lines = linesText.split('\n');
		let text = '[ul]';
		lines.forEach(
			function (value) {
				if (value.trim() > '') {
					text += '[li]' + value + '[/li]';
				}
			})
		text += '[/ul]';
		const curPos = x.waf[x.wad[props.id].wafId].elements['posting'].reference.current.selectionStart;
		const curVal = x.waf.get(x.wad[props.id].wafId, 'posting');
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		
		x.waf.set(x.wad[props.id].wafId, 'posting', leftValue + text + rightValue);
		x.waf.focus(x.wad[props.id].wafId, 'posting');
		
	}

	function addLink() {
		x.wab.modal.hide();
		x.wad[props.id].hide();
		const curPos = x.waf[x.wad[props.id].wafId].elements['posting'].reference.current.selectionStart;
		const curVal = x.waf.get(x.wad[props.id].wafId, 'posting');
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		const url = x.waf.get(props.id, 'url').trim();
		// Ohne Titel entstand hier "[url=...][/url]" - ein Link ohne sichtbaren
		// Text, im Beitrag also eine leere Stelle (Mitglieder-Bugreport
		// 2026-08-14: "bleibt mein Feld leer"). Dann die Adresse selbst anzeigen.
		const urlTitle = x.waf.get(props.id, 'url-title').trim() || url;
		x.waf.set(x.wad[props.id].wafId, 'posting', leftValue + '[url=' + url + ']' + urlTitle + '[/url]' + rightValue);
		x.waf.focus(x.wad[props.id].wafId, 'posting');
	}

	return (

		<Dialog id={props.id} x={x}   title={props.title} classes={'dialog-add-content ' + classes} closeIcon="1" >
			<Form x={x}   wafId={props.id} dialogId={props.id} sendButtonTitle="Übernehmen" classes="webapp-form" onSubmit={send}>
				{props.children}
			</Form>
		</Dialog>

	)
};
